import styled from 'styled-components';

export const ColumnsWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const Column = styled.div`
  width: 50%;
`;

export const ColumnCard = styled.div`
  margin-bottom: 1rem;
  padding: 1.5rem 1.25rem;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.tokens.colors.neutral[100]};
  box-shadow: 0px 5px 10px -7px rgba(0, 0, 0, 0.2);
`;

export const ColumnCardTitle = styled.h2`
  margin-bottom: 0.75rem;
  color: #2d2d30;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.25rem;
`;

export const ColumnCardDarkText = styled.h4`
  margin: 0;
  color: #000;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.25rem;
`;

export const ColumnCardLightText = styled.div`
  margin: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1rem;

  p {
    margin: 0;
  }
`;

export const TextRow = styled.div`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const PaymentMethodPlaceholderDisabled = styled.div`
  display: inline-block;
  min-width: 11.35rem;
  height: 2rem;
  margin: 0.35rem 0 0.5rem 0;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.tokens.colors.neutral[100]};
  background: ${({ theme }) => theme.tokens.colors.neutral[200]};
  color: ${({ theme }) => theme.tokens.colors.text[400]};
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1rem;
`;

export const SecurityLinksTextWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const SecurityLinksList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0;
`;

export const SecurityLinksListItem = styled.li`
  list-style-type: none;
`;
